import { useLocation } from 'react-router-dom';
import { ArcRoutes } from '../../pages/arc/constants/routes';
import { PositionTypes } from '../../pages/arc/features/employment/employment-model';
import { GpsType } from '../components/layout/layout-models';

export function getBasePath(language: string, appName?: string) {
	const appPath = appName ? `/${appName}` : '';

	return `${language === 'en' ? '' : `/${language}`}/services${appPath}`;
}


export function getGpsTypeByCompPath() {
	const currentPath = window?.location?.pathname;

	if (currentPath.includes(`${ArcRoutes.Compensation}${ArcRoutes.ScheduledHoursHistory}`)) {
		return GpsType.SCHEDULED_HOUR_HISTORY;
	}
	if (currentPath.includes(`${ArcRoutes.Compensation}${ArcRoutes.ScheduledHours}`)) {
		return GpsType.UPDATE_SCHEDULED_HOUR;
	}
	if (currentPath.includes(`${ArcRoutes.Compensation}${ArcRoutes.ScheduledPayment}`)) {
		return GpsType.SCHEDULED_PAYMENT;
	}
	if (currentPath.includes(`${ArcRoutes.Compensation}${ArcRoutes.OneTimePayment}`)) {
		return GpsType.ONE_TIME_PAYMENT;
	}
	if (currentPath.includes(`${ArcRoutes.Compensation}${ArcRoutes.History}`)) {
		return GpsType.COMPENSATION_HISTORY;
	}
	return GpsType.COMPENSATION;

}


export function getGpsTypeByEmploymentPath() {
	const { state } = useLocation<any>();
	const positionType: PositionTypes = state?.positionType;
	const positionId: string = state?.positionId;

	if (positionType === PositionTypes.Stipendiary) {
		return positionId ? GpsType.EDIT_STIPE : GpsType.UPDATE_STIPE;
	}

	if (positionType === PositionTypes.NonStipendiary) {
		return positionId ? GpsType.EDIT_NONSTIPE : GpsType.ADD_NONSTIPE;
	}
	return GpsType.EMPLOYMENT;

}